import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
  accent?: 'blue' | 'green' | 'gold';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  blue: 'bg-brand-blue',
  green: 'bg-brand-green',
  gold: 'bg-brand-goldDark'
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text,
  accent = 'blue'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-blueMid p-6 md:p-8" data-id="element-296" data-mp="31ybelc4lfdgj">
      <div className="mb-4 flex items-center" data-id="element-297" data-mp="2x11pxyp135tr">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-298" data-mp="2s28gqigry0ze">
          {initials}
        </div>
        <div data-id="element-299" data-mp="qb511es11w7z">
          <div className="mb-1 flex text-brand-amber" data-id="element-300" data-mp="q896m0fe1poa">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-301" data-mp="m51cxwwuzfaj" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-302" data-mp="77s7jzaq0azt">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-303" data-mp="79v6j8tupego">
            {location}
            {product ? ` — ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-304" data-mp="zxhcgnqjwv6p">“{text}”</p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Mendoza',
  product: 'Terapeuta holística',
  accent: 'blue',
  text: 'Por primera vez tengo un sistema completo para mis sesiones. Los consultantes perciben la diferencia desde el primer momento y cuando les muestro el mapa visual para organizar las áreas de exploración, sienten que están en manos de una profesional real.'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  location: 'Buenos Aires',
  product: 'Terapeuta',
  accent: 'green',
  text: 'El Tomo III de prácticas simbólicas solo ya vale todo el pack. Antes no sabía cómo cerrar las sesiones. Ahora propongo ejercicios de integración concretos y trabajo con mayor estructura y claridad en la práctica.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Rosario',
  product: 'Terapeuta en formación',
  accent: 'gold',
  text: 'Recién empezaba y el Kit Maestro me dio la estructura que necesitaba desde la primera sesión. Las 7 preguntas me permiten ordenar la exploración del contexto emocional sin quedarme en blanco. Llegué al consultorio con criterio desde el día uno.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-305" data-mp="vswxe1w6dten">
      <div className="mx-auto max-w-3xl" data-id="element-306" data-mp="vrvi1l84mkr4">
        <TestimonialCard {...testimonials[0]} data-id="element-307" data-mp="qt0rfx3x3rwg" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-308" data-mp="32fum1quwapl7">
      <div className="mb-10 text-center" data-id="element-309" data-mp="32j0bj77frthg">
        <h2 className="font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-310" data-mp="37f7hgzzu14ze">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-311" data-mp="3ggoto7a4cmit">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-312" data-mp="2jqxy04q3ctbf" />)}
      </div>
    </Section>;
}